const SELECT = "quantity/SELECT";
const SET_VALUE = "quantity/SET_VALUE";

export default {
    SELECT,
    SET_VALUE
};



// WEBPACK FOOTER //
// ./dev/ducks/quantity/types.js